import React, { FC } from 'react';
import { Props } from './types';
import Rating from './Rating';
import {
  Container,
  Name,
  Date,
  CommentContainer,
  OrderContainer,
  Text,
  Avatar,
} from './styles';

const Comment: FC<Props> = ({ name, date, comment, rating, order }) => {
  return (
    <Container>
      <div>
        <Name>{name}</Name>
        <Date>{date}</Date>
      </div>
      <div>
        <Rating rating={rating} />
        <CommentContainer>{comment}</CommentContainer>
      </div>
      <OrderContainer>
        <Avatar src={order.logo} alt={order.name} />
        <Text>{order.name}</Text>
      </OrderContainer>
    </Container>
  );
};

export default Comment;
